import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgIf } from '@angular/common';
import { Console } from 'console';
import { Router } from '@angular/router';

interface FHIRResponse {
    total: number;
    entry?: Array<{
        resource: {
            subject: {
                reference: string;
            };
        };
    }>;
}

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, AngularSvgIconModule, NgIf],

})

export class RegisterComponent implements OnInit {
    registerForm!: FormGroup;
    serviceRequestValid: boolean | null = null;
    patientResourceId: string | null = null;
    checkingServiceRequest = false;



    constructor(private fb: FormBuilder, private http: HttpClient, private router: Router) { }



    ngOnInit(): void {
        this.registerForm = this.fb.group({
            username: ['', [Validators.required]], // Add username form control
            email: ['', [Validators.required]], // Add username form control
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(8),
                    this.passwordValidator,
                ],
            ],
            confirmPassword: ['', [Validators.required,
            Validators.minLength(8),
            this.passwordMatchValidator
            ]],
            serviceRequestId: ['', Validators.required]

        }, {
            validators: this.passwordMatchValidator,
        });
    }


    passwordValidator(control: any) {
        const value = control.value;
        if (!/[A-Z]/.test(value)) {
            return { uppercase: true };
        }
        if (!/[a-z]/.test(value)) {
            return { lowercase: true };
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
            return { specialCharacter: true };
        }
        return null;
    }


    passwordMatchValidator(group: FormGroup) {
        const password = group.get('password')?.value;
        const confirmPassword = group.get('confirmPassword')?.value;
        console.log(password, confirmPassword);
        return password === confirmPassword ? null : { passwordMismatch: true };
    }

    onSubmit() {
        if (this.registerForm.valid) {
            console.log('Form submitted', this.registerForm.value);
        }
    }



    /** ✅ Check if serviceRequestId is valid */
    checkServiceRequest() {
        const serviceRequestId = this.registerForm.get('serviceRequestId')?.value;
        if (!serviceRequestId) return;

        this.checkingServiceRequest = true;
        this.http.get(`https://person.mhnexus.com/api/v1/auth/get-patient?serviceRequestId=${serviceRequestId}`)
            .subscribe(
                (response: any) => {
                    this.checkAndSavePatientId(response);


                },
                error => {
                    this.serviceRequestValid = false;
                    this.patientResourceId = null;
                    this.checkingServiceRequest = false;
                }
            );
    }

    checkAndSavePatientId(response: FHIRResponse): void {
        this.serviceRequestValid = false;
        this.patientResourceId = null;
        this.checkingServiceRequest = false;

        if (response.total == 1.0) {
            const entry = response.entry?.[0]; // Get the first entry
            if (entry?.resource?.subject?.reference) {
                const reference = entry.resource.subject.reference;
                const uuid = reference.split("Patient/")[1]; // Extract the UUID
                if (uuid) {
                    this.patientResourceId = uuid; // Save globally
                    console.log("Saved Patient UUID:", this.patientResourceId);
                    this.serviceRequestValid = true;
                    this.checkingServiceRequest = false;

                }
            }
        }
    }



    /** ✅ Submit the Register Form */
    register() {
        if (!this.registerForm.valid || !this.serviceRequestValid || !this.patientResourceId) return;

        const { username, email, password, serviceRequestId } = this.registerForm.value;
        const requestBody = {
            "username": username,
            "password": password,
            "email": email,
            "defaultLaunchContexts": [
                {
                    "contextType": "patient",
                    "resourceId": serviceRequestId
                }
            ]
        };

        this.http.post(`https://person.mhnexus.com/api/v1/smile/create-account`, requestBody)
            .subscribe(
                response => {
                    window.location.href = 'https://appointment.mhnexus.com/';

                    alert('Registration successful!')
                },
                error => {
                    if (error.status === 500) {
                        alert('Service Request ID already used');
                    } else {
                        alert('Registration failed. Try again.');
                    }
                }
            );
    }
}